export function FormattedNumber({ value, locale = "en-US", options }) {
  const formatter = new Intl.NumberFormat(locale, options);
  return <span>{formatter.format(value)}</span>;
}
